import type { PosteringsvarselDto, ValutaEnhet, VarseloppgaverDto } from '@es/shared';
import { formaterBelop, manedsnavn } from '../../felles/format.js';

/**
 * Uvanlige posteringer, slik siden og oppgavene sier det. Se
 * `domain/posteringsvarsel.ts` for hva som er uvanlig.
 */

const ienhet = (enhet: ValutaEnhet): string => (enhet === 'kr_1000' ? ' (tusen kroner)' : ' kr');

/** «10400 Overtid». */
export const kontotekst = (v: Pick<PosteringsvarselDto, 'kontonummer' | 'kontonavn'>): string =>
  v.kontonummer === null ? v.kontonavn : `${v.kontonummer} ${v.kontonavn}`;

/** «90 000 kr, vanligvis 20 000. I september i fjor: 20 000.» */
export function varseltekst(
  v: Pick<PosteringsvarselDto, 'belop' | 'vanlig' | 'fjoraret'>,
  maned: number,
  enhet: ValutaEnhet,
): string {
  const fjor =
    v.fjoraret === null ? '' : ` I ${manedsnavn(maned)} i fjor: ${formaterBelop(v.fjoraret)}.`;
  return `${formaterBelop(v.belop)}${ienhet(enhet)}, vanligvis ${formaterBelop(v.vanlig)}.${fjor}`;
}

/** Oppgaven: hva, hvor, og den største. */
export function varseloppgavetekst(o: VarseloppgaverDto['oppgaver'][number]): {
  tittel: string;
  detalj: string;
} {
  const flere = o.antall > 1 ? ` — og ${String(o.antall - 1)} til` : '';
  return {
    tittel: `Se på uvanlige posteringer i ${manedsnavn(o.maned)} — ${o.virksomhetNavn}`,
    detalj: `${o.storste.kontonavn}: ${formaterBelop(o.storste.belop)}${ienhet(o.valutaEnhet)}, vanligvis ${formaterBelop(o.storste.vanlig)}${flere}. Er den riktig før prognosen leveres?`,
  };
}
